import React, { Component, Fragment, useState } from 'react';
import * as d3 from 'd3';

class Home extends Component {


    state = {
        addFlag: true,
        colRef: 1
    }
    mobilecheck = function() {
        var check = false;
        (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
        return check;
    };
    // get cursor position in main svg
    cursorPoint = (evt) => {
        var svg = document.getElementById("main-svg");
        // var svg = evt.target;
        var pt = svg.createSVGPoint();
        if(this.mobilecheck()){

            pt.x = evt.touches[0].clientX;
            pt.y = evt.touches[0].clientY;
        }else{

            pt.x = evt.clientX;
            pt.y = evt.clientY;
        }
        return pt.matrixTransform(svg.getScreenCTM().inverse());
    }
    mFlag = ()=>this.mobilecheck();

    rand = (min,max)=>parseInt((Math.random()*(max+1))+min);

    drag = (event) =>{

        let addFlag = this.state.addFlag;
        let colRef = this.state.colRef;

        var loc = this.cursorPoint(event);
        let x = loc.x;
        let y = loc.y;

        // console.log(x)

        if(addFlag){


            this.setState({
                addFlag: !addFlag
            })

            d3.select('#main-svg').append('circle')
                .attr('cx',x)
                .attr('cy',y)
                .attr('r',1)
                // .attr("pathLength", 100)
                // .attr("stroke-dasharray", '0, 100')
                .style('fill', 'none')
                .style('stroke-width', 0.1)
                // .style('stroke', ()=>'hsl('+((359*x)/100).toFixed(0)+', 100%, 50%)')
                .style('stroke', ()=>'hsl('+colRef+', 100%, 50%)')
                .transition()
                .duration(1000)
                .attr("r", 15)
                .style("opacity", 0.5)
                .style('stroke-width', 2)
                // .attr("stroke-dasharray", '101')

                // .attr("stroke-dasharray", ()=>{
                //     let totalLength = this.node().getTotalLength();
                //     return totalLength
                // })
                .ease(d3.easeSinOut)
        
                .each(function(d, i, n) {
                    // this = n[i]
                    d3.select(this)
                    .transition()
                    .delay(1000)
                    .duration(1000)
                    .attr('r', 1)
                    .style('stroke-width', '0.1px')
                    .style("opacity", 0.5)
                    // .attr("stroke-dasharray", '2, 10')
                    .remove();
                    
                });
        }

        
        
            
            
    }

    bodyOverflowFix = () => {
        document.body.classList.add('no-overflow');
    }
    componentDidMount(){

        this.bodyOverflowFix();
        

        // this.addEvent()
        setInterval(()=>{
            let colRef = this.state.colRef;
            colRef === 359 ? colRef=0 : colRef++;
            this.setState({
                colRef: colRef
            })
            
        },10);

        setInterval(()=>{

            let addFlag = this.state.addFlag
            this.setState({
                addFlag: !addFlag
            })
        },40);
    }
    

    render() {

      return (
        <Fragment>
             <div id="main-container" >
                <div style={{flex:1,height:"200px"}}>
                    <svg 
                        id="main-svg" 
                        width="100%" 
                        height="100%" 
                        viewBox="0 0 100 100" 
                        // preserveAspectRatio="xMidyMid" 
                        preserveAspectRatio="none" 
                        // onClick={this.mainSvgClickEvent}
                        // onMouseEnter={this.mainSvgMouseEnterEvent}
                        // onMouseLeave={this.mainSvgMouseLeaveEvent}
                        onMouseMove={this.drag}
                        onTouchMove={this.drag}
                    >
                    </svg>
                </div>
            </div>
        </Fragment>
      );
    }
  }
  
  export default Home;